import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const GenresAndLanguagesRow = styled.div`
  font-size: 10px;
  color: ${colors.mainText};

  &:first-child {
    margin-bottom: 4px;
  }
`
